export default "__VITE_ASSET__BrwzDKU1__"